const Svg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={"100%"}
    height={"100%"}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M416 128L192 384l-96-96"
    />
  </svg>
);
export default Svg;
